const IconList = {
  chevronDown: (
    <svg width="20" height="21" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 13.625 5.625 9.25l.875-.875 3.5 3.5 3.5-3.5.875.875L10 13.625Z" />
    </svg>
  ),
  chevronUp: (
    <svg width="20" height="21" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 7.375 5.625 11.75l.875.875 3.5-3.5 3.5 3.5.875-.875L10 7.375Z" />
    </svg>
  ),
  chevronRight: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
      <g clipPath="url(#a)">
        <path d="M13.75 10 7.5 16.25l-.875-.875L12 10 6.625 4.625 7.5 3.75 13.75 10Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  chevronLeft: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
      <g clipPath="url(#a)">
        <path d="m6.25 10 6.25 6.25.875-.875L8 10l5.375-5.375-.875-.875L6.25 10Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M20 0H0v20h20z" />
        </clipPath>
      </defs>
    </svg>
  ),
  arrowRight: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g clipPath="url(#a)">
        <path d="m11.25 3.75-.894.87 4.738 4.755H2.5v1.25h12.594l-4.738 4.733.894.892L17.5 10l-6.25-6.25Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  creatopyLogo: (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="60" viewBox="0 0 120 60">
      <g id="Creatopy Logo Clean">
        <path
          id="Path"
          d="M7.25662 30C7.25665 26.5519 10.0519 23.7567 13.5 23.7567V16.5C6.04416 16.5 0 22.5442 0 30C0 37.4558 6.04416 43.5 13.5 43.5V36.2433C10.0519 36.2433 7.25664 33.4481 7.25662 30Z"
          fill="#C7C8CB"
        />
        <g id="Clipped">
          <mask id="mask0_6939_9703" maskUnits="userSpaceOnUse" x="13" y="3" width="28" height="54">
            <g id="mask 2">
              <path
                id="Vector"
                d="M13.5 43.5C21.0106 43.5 27.0992 37.5445 27.0992 30C27.0992 22.4554 21.0106 16.5 13.5 16.5V3H13.6214C28.466 3 40.5 15.0883 40.5 30C40.5 44.9116 28.466 57 13.6214 57H13.5V43.5Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask0_6939_9703)">
            <g id="Ellipse 14" filter="url(#filter0_f_6939_9703)">
              <circle cx="13.5" cy="30" r="21" transform="rotate(-90 13.5 30)" fill="url(#paint0_linear_6939_9703)" />
            </g>
          </g>
        </g>
        <g id="Group">
          <path
            id="Path_2"
            d="M48.0717 25.2617C49.2788 25.2617 50.2047 25.5513 50.9654 26.0962L50.4362 27.833C49.7583 27.4073 49.1465 27.1179 48.204 27.1179C46.7654 27.1179 45.6244 28.1566 45.6244 30.0298C45.6244 31.8179 46.7323 32.8906 48.1544 32.8906C48.9804 32.9165 49.7978 32.7105 50.5189 32.2947L50.8331 33.9804C50.1717 34.4401 49.2292 34.7468 47.9725 34.7468C45.4591 34.7468 43.4087 33.0778 43.4087 30.115C43.4087 27.0156 45.5418 25.2617 48.0717 25.2617Z"
          />
          <path
            id="Shape"
            d="M62.5753 25.2788C64.9894 25.2788 66.891 26.7773 66.891 30.0126C66.8941 30.2464 66.8775 30.4801 66.8414 30.7109H60.2768C60.4918 32.2435 61.4343 33.0097 63.1209 33.0097C64.1652 33.0356 65.1976 32.7771 66.1138 32.2604L66.4776 33.8271C65.5186 34.4062 64.2949 34.7637 62.7902 34.7637C59.7477 34.7637 58.0776 32.9927 58.0776 30.0808C58.0776 27.1689 59.9792 25.2788 62.5753 25.2788ZM62.5422 26.9986C61.2524 26.9986 60.4587 27.7991 60.2768 29.3486H64.7083C64.5595 27.782 63.8319 26.9986 62.5422 26.9986Z"
          />
          <path
            id="Shape_2"
            d="M90.0166 25.2617C92.5134 25.2617 94.8614 26.9136 94.8614 29.9957C94.8614 33.0609 92.5961 34.7468 89.9834 34.7468C87.4371 34.7468 85.2378 33.112 85.2378 30.0469C85.2378 26.9817 87.47 25.2617 90.0166 25.2617ZM90.0495 27.0837C88.6772 27.0837 87.4535 28.0204 87.4535 29.9788C87.4535 31.937 88.5779 32.9077 90.0166 32.9077C91.5046 32.9077 92.6456 31.9199 92.6456 30.0127C92.6456 28.0885 91.4551 27.0837 90.0495 27.0837Z"
          />
          <path
            id="Path_3"
            d="M79.4165 23.2776H81.5206V25.516H84.5806V27.1881H81.5206V32.6879H84.5806V34.4687H81.5408C80.3676 34.4687 79.4165 33.4892 79.4165 32.281V23.2776Z"
          />
          <path
            id="Path_4"
            d="M57.6481 25.4944H57.2531C56.3632 25.4944 55.5097 25.8585 54.8805 26.5065L54.4363 26.964V25.4952L54.4424 25.4944H52.2889L52.2856 34.5182L54.4331 34.5191L54.4356 27.5134H57.6481V25.4944Z"
          />
          <path
            id="Path_5"
            d="M113.117 25.5168L110.719 32.1411L108.42 25.5168H105.973L109.611 34.5761L109.143 35.6563H107.425V37.4251H109.466C110.159 37.4251 110.783 36.9969 111.051 36.3391L115.448 25.5168H113.117Z"
          />
          <path
            id="Shape_3"
            d="M72.243 25.2788C73.5824 25.2788 74.9457 26.1304 75.3682 27.4404V25.5172H77.4682V34.5253H75.3682V32.3638C74.9472 33.7759 73.6774 34.7372 72.243 34.7297C69.9777 34.7297 67.9438 33.112 67.9438 30.0298C67.9438 26.9476 69.9115 25.2788 72.243 25.2788ZM75.3682 29.9276C74.9383 28.1907 73.8469 27.1179 72.5572 27.1179C71.2013 27.1179 70.1595 28.0885 70.1595 29.9957C70.1595 31.8348 71.2013 32.8906 72.5572 32.8906C73.9627 32.8906 74.9713 31.6985 75.3682 30.0127V29.9276Z"
          />
          <path
            id="Shape_4"
            d="M98.2897 25.5172V27.4915C98.9043 26.1265 100.059 25.2788 101.415 25.2788C103.746 25.2788 105.714 26.9816 105.714 30.0638C105.714 33.146 103.68 34.7637 101.415 34.7637C100.092 34.7637 98.8141 33.7771 98.3724 32.5511V37.4253H96.2559V25.5172H98.2897ZM101.101 27.1179C99.7779 27.1179 98.6866 28.2929 98.2897 30.0298C98.67 31.7497 99.7283 32.9077 101.084 32.9077C102.457 32.9077 103.498 31.8519 103.498 30.0298C103.498 28.1225 102.457 27.1179 101.101 27.1179Z"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_6939_9703"
          x="-12"
          y="4.5"
          width="51"
          height="51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.25" result="effect1_foregroundBlur_6939_9703" />
        </filter>
        <linearGradient id="paint0_linear_6939_9703" x1="-7.5" y1="30" x2="34.5" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="#B1DD00" />
          <stop offset="1" stopColor="#00DBDB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  burgerMenu: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g id="menu 1" clipPath="url(#clip0_6967_14631)">
        <path id="Vector" d="M28 6H4V8H28V6Z" />
        <path id="Vector_2" d="M28 24H4V26H28V24Z" />
        <path id="Vector_3" d="M28 12H4V14H28V12Z" />
        <path id="Vector_4" d="M28 18H4V20H28V18Z" />
      </g>
      <defs>
        <clipPath id="clip0_6967_14631">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  close: (
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g id="menu 1">
        <path
          id="Vector"
          d="M17.4141 16L26 7.4141L24.5859 6L16 14.5859L7.4143 6L6 7.4141L14.5859 16L6 24.5859L7.4143 26L16 17.4141L24.5859 26L26 24.5859L17.4141 16Z"
        />
      </g>
    </svg>
  ),
  closeSmall: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path d="M21.6568 11.7574L20.2426 10.3431L16 14.5858L11.7574 10.3431L10.3431 11.7574L14.5858 16L10.3431 20.2426L11.7574 21.6568L16 17.4142L20.2426 21.6568L21.6568 20.2426L17.4142 16L21.6568 11.7574Z" />
    </svg>
  ),
  languages: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path d="M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Zm9 9.75h-4.5a18.194 18.194 0 0 0-2.092-7.912A9 9 0 0 1 21 11.25ZM12 21a3.762 3.762 0 0 1-.502 0A16.388 16.388 0 0 1 9 12.75h6A16.387 16.387 0 0 1 12.525 21 3.74 3.74 0 0 1 12 21Zm-3-9.75c.075-2.921.93-5.77 2.475-8.25a4.5 4.5 0 0 1 1.005 0A16.387 16.387 0 0 1 15 11.25H9Zm.57-7.912A18.195 18.195 0 0 0 7.5 11.25H3a9 9 0 0 1 6.592-7.912H9.57ZM3.037 12.75h4.5c.079 2.76.784 5.466 2.063 7.913a9 9 0 0 1-6.563-7.913Zm11.37 7.913A18.194 18.194 0 0 0 16.5 12.75H21a9 9 0 0 1-6.592 7.913Z" />
    </svg>
  ),
  filter: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <g fill="#000" clipPath="url(#a)">
        <path d="M15 4.344h-2.05c-.25-1.15-1.25-2-2.45-2-1.2 0-2.2.85-2.45 2H1v1h7.05c.25 1.15 1.25 2 2.45 2 1.2 0 2.2-.85 2.45-2H15v-1Zm-4.5 2c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5 1.5.65 1.5 1.5-.65 1.5-1.5 1.5ZM1 12.344h2.05c.25 1.15 1.25 2 2.45 2 1.2 0 2.2-.85 2.45-2H15v-1H7.95c-.25-1.15-1.25-2-2.45-2-1.2 0-2.2.85-2.45 2H1v1Zm4.5-2c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5-1.5-.65-1.5-1.5.65-1.5 1.5-1.5Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .344h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  checkBoxSelected: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path d="M13 2.266H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1Zm-6 8.75L4.5 8.537l.795-.771L7 9.438l3.704-3.672.796.788L7 11.016Z" />
      <path fill="#fff" d="M7 11.016 4.5 8.537l.795-.771L7 9.438l3.704-3.672.796.788L7 11.016Z" />
    </svg>
  ),
  checkBox: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path d="M13 2.266H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1Zm-10 11v-10h10v10H3Z" />
    </svg>
  ),
  searchNotFound: (
    <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124" fill="none">
      <path
        fill="#E6E8EB"
        d="M62.112 123.638c33.892 0 61.366-27.474 61.366-61.366 0-33.891-27.474-61.366-61.366-61.366C28.221.906.746 28.381.746 62.272c0 33.892 27.475 61.366 61.366 61.366Z"
      />
      <path fill="#51535B" d="m42.714 78.52 7.984 7.983-24.201 24.202a5.646 5.646 0 0 1-7.984-7.984l24.201-24.202Z" />
      <path
        fill="#51535B"
        d="M66.235 94.246c17.982 0 32.56-14.577 32.56-32.56 0-17.983-14.578-32.561-32.56-32.561-17.983 0-32.561 14.578-32.561 32.56 0 17.984 14.578 32.561 32.56 32.561Z"
      />
      <path
        fill="#C7C8CB"
        d="M66.117 86.894c13.881 0 25.134-11.253 25.134-25.135 0-13.88-11.253-25.134-25.134-25.134-13.882 0-25.135 11.253-25.135 25.135 0 13.881 11.254 25.134 25.135 25.134Z"
      />
    </svg>
  ),
  starFilled: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#616161"
        d="M8 1 5.727 5.61.64 6.345l3.68 3.59L3.45 15 8 12.61 12.55 15l-.87-5.065 3.68-3.585-5.085-.74L8 1Z"
      />
    </svg>
  ),
  checkmark: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9.75 18L3 11.25L4.0605 10.1895L9.75 15.8782L19.9395 5.68945L21 6.74995L9.75 18Z" fill="#212121" />
    </svg>
  ),
  empty: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g opacity="0.4">
        <path
          d="M18 7.05L16.95 6L12 10.95L7.05 6L6 7.05L10.95 12L6 16.95L7.05 18L12 13.05L16.95 18L18 16.95L13.05 12L18 7.05Z"
          fill="#212121"
        />
      </g>
    </svg>
  ),
  customPricing: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2H28C29.1035 2 30 2.8965 30 4V10C30 11.1035 29.1035 12 28 12H25V10H28V4H18V10H21.5771L23.8867 14L22.1543 15L20.4229 12H18C16.8965 12 16 11.1035 16 10V4C16 2.8965 16.8965 2 18 2ZM12.958 30L14.6904 31L17.577 26H21.9999C24.209 26 25.9999 24.2091 25.9999 22V17H23.9999V22C23.9999 23.1046 23.1045 24 21.9999 24H16.4228L12.958 30ZM10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18ZM15 17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16C14.5523 16 15 16.4477 15 17ZM18 18C18.5523 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16C17.4477 16 17 16.4477 17 17C17 17.5523 17.4477 18 18 18ZM6 26H12V24H6C4.8954 24 4 23.1046 4 22V12C4 10.8954 4.8954 10 6 10H14V8H6C3.7909 8 2 9.7909 2 12V22C2 24.2091 3.7909 26 6 26Z"
        fill="#121214"
      />
    </svg>
  ),
  arrowDown: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M12.295 8.295L8.5 12.085V2H7.5V12.085L3.705 8.295L3 9L8 14L13 9L12.295 8.295Z" />
    </svg>
  ),
  information: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
      <path d="M17 22v-8h-4v2h2v6h-3v2h8v-2h-3zM16 8a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 8Z" />
      <path d="M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14Zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4Z" />
      <path
        d="M0 0h32v32H0z"
        data-name="&lt;Transparent Rectangle&gt;"
        style={{
          fill: 'none',
        }}
      />
    </svg>
  ),
  theBriefLogo: (
    <svg xmlns="http://www.w3.org/2000/svg" width="122" height="22">
      <g clipPath="url(#a)">
        <path
          fill="var(--color-text-primary)"
          d="M114.399 21.558h3.24v-10.89H122V7.703h-4.361V6.66c0-1.989 1.277-3.251 3.146-3.251H122V.442h-1.184c-3.894 0-6.417 2.651-6.417 6.313v14.803Zm-12.182-8.333c.405-1.925 1.87-3.188 3.739-3.188 1.994 0 3.427 1.357 3.583 3.188h-7.322Zm-6.355-8.112 2.305-2.335L95.862.442l-2.305 2.336 2.305 2.335ZM106.08 22c2.991 0 5.421-1.452 6.605-4.545h-3.427c-.623 1.136-1.807 1.704-3.146 1.704-2.057 0-3.552-1.357-3.801-3.409h10.717v-.6c0-5.302-3.209-7.89-7.01-7.89-4.05 0-7.165 3.156-7.165 7.449C98.853 19 101.78 22 106.08 22Zm-11.838-.442h3.24V7.702h-3.24v13.856Zm-8.287 0h3.24v-7.575c0-1.926 1.246-3.314 3.146-3.314h.592V7.702h-.623c-3.925 0-6.355 2.65-6.355 6.312v7.544ZM73.742 9.311V6.218c0-2.21 1.527-3.251 3.147-3.251 1.62 0 3.053 1.042 3.053 3.125 0 1.925-1.308 3.22-3.178 3.22h-3.022Zm0 9.28v-6.376h4.05c2.088 0 3.365 1.357 3.365 3.188 0 1.83-1.277 3.188-3.365 3.188h-4.05Zm-3.364 2.967h7.82c3.707 0 6.386-2.746 6.386-6.155 0-2.651-1.495-4.577-3.614-5.366 1.464-.978 2.306-2.493 2.306-4.324C83.276 2.557 80.908 0 76.982 0c-3.925 0-6.604 2.746-6.604 6.218v15.34Zm-12.182-8.333c.405-1.925 1.87-3.188 3.739-3.188 1.994 0 3.427 1.357 3.583 3.188h-7.322ZM62.06 22c2.99 0 5.42-1.452 6.604-4.545h-3.427c-.623 1.136-1.807 1.704-3.146 1.704-2.056 0-3.552-1.357-3.801-3.409h10.717v-.6c0-5.302-3.209-7.89-7.01-7.89-4.05 0-7.165 3.156-7.165 7.449C54.832 19 57.76 22 62.059 22Zm-21.56-.442h3.24v-8.207c0-2.177 1.59-3.314 3.334-3.314 1.745 0 3.147 1.137 3.147 3.314v8.207h3.24v-8.427c0-3.346-1.9-5.871-5.514-5.871-1.838 0-3.365.694-4.206 1.736V4.419H40.5v17.14Zm-6.604 0h3.365V3.408h6.48V.443H27.416v2.967h6.48v18.15Z"
        />
        <path
          fill="#CA5936"
          d="M21.683 7.07c0-3.756-2.772-6.628-6.822-6.628H7.134C2.897.442 0 3.409 0 7.07c0 1.484.467 2.746 1.34 3.946C.498 12.152 0 13.446 0 14.93c0 3.756 2.773 6.628 6.823 6.628h8.038c3.956 0 6.822-2.967 6.822-6.628 0-1.484-.467-2.81-1.308-3.946a6.356 6.356 0 0 0 1.308-3.914ZM6.823 2.241h3.458c-.717.537-1.215 1.136-1.558 1.8H6.885c-1.963 0-3.146 1.451-3.146 3.03 0 1.577 1.183 3.03 3.146 3.03h1.153V11.9H6.823c-2.773 0-4.954-2.147-4.954-4.83 0-2.683 2.181-4.829 4.954-4.829Zm1.34 3.598a7.84 7.84 0 0 0-.125 1.231v1.231H6.823a1.225 1.225 0 0 1-1.215-1.23c0-.664.53-1.232 1.215-1.232h1.34Zm-.125 7.86v1.23c0 .695-.499 1.232-1.215 1.232-.717 0-1.215-.537-1.215-1.231 0-.695.53-1.231 1.215-1.231h1.215Zm6.823 6.06h-3.459a5.17 5.17 0 0 0 1.527-1.8h1.87c2.055 0 3.146-1.451 3.146-3.03 0-1.578-1.09-3.03-3.147-3.03h-1.152V10.1h1.215c2.772 0 4.953 2.147 4.953 4.83 0 2.683-2.18 4.829-4.953 4.829Zm-1.34-3.598c.062-.38.125-.821.125-1.231v-1.231h1.215c.685 0 1.215.568 1.215 1.23 0 .663-.53 1.232-1.215 1.232h-1.34Zm.125-7.86v-1.23c0-.695.498-1.232 1.215-1.232.716 0 1.215.537 1.215 1.231 0 .695-.53 1.231-1.215 1.231h-1.215Zm5.39 1.358a5.4 5.4 0 0 0-1.745-.916c.405-.442.654-1.073.654-1.799 0-1.8-1.402-2.904-3.053-2.904s-3.116 1.136-3.116 3.03v7.86c0 2.683-2.212 4.829-4.953 4.829-2.742 0-4.954-2.083-4.954-4.83 0-.978.28-1.83.78-2.588.466.38 1.09.695 1.744.916-.405.442-.654 1.073-.654 1.799 0 1.8 1.401 2.904 3.053 2.904 1.65 0 3.115-1.137 3.115-3.03V7.07c0-2.683 2.212-4.829 4.954-4.829 2.741 0 4.953 2.083 4.953 4.83 0 .978-.28 1.83-.779 2.588Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h122v22H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  arrowUpRight: (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path d="M8 5v1.5h9.442L5 18.942 6.058 20 18.5 7.558V17H20V5H8Z" />
    </svg>
  ),
  star: (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M8.5 2.29349L6.64538 6.05164L2.5 6.65083L5.5 9.57746L4.79076 13.7065L8.5 11.7582L12.2092 13.7065L11.5 9.57746L14.5 6.6549L10.3546 6.05164L8.5 2.29349Z"
        fill="#CA5936"
      />
    </svg>
  ),
  theBriefFooterLogo: (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="47" viewBox="0 0 49 47" fill="none">
      <path
        fill="#CA5936"
        d="M48.457 14.7368C48.457 6.38596 42.2607 0 33.2098 0H15.9435C6.47486 0 0 6.59649 0 14.7368C0 18.0351 1.04433 20.8421 2.99375 23.5087C1.11395 26.0351 0 28.9123 0 32.2105C0 40.5614 6.19637 46.9473 15.2473 46.9473H33.2098C42.0518 46.9473 48.457 40.3508 48.457 32.2105C48.457 28.9123 47.4127 25.9649 45.5329 23.4386C47.4127 20.9824 48.457 18.0351 48.457 14.7368ZM15.2473 4H22.9753C21.374 5.19298 20.2601 6.52631 19.4942 7.99999H15.3865C11.0003 7.99999 8.35466 11.2281 8.35466 14.7368C8.35466 18.2456 11.0003 21.4737 15.3865 21.4737H17.9625V25.4737H15.2473C9.05088 25.4737 4.17733 20.7017 4.17733 14.7368C4.17733 8.77192 9.05088 4 15.2473 4ZM18.241 12C18.1018 12.8421 17.9625 13.8245 17.9625 14.7368V17.4737H15.2473C13.7156 17.4737 12.532 16.2105 12.532 14.7368C12.532 13.2631 13.7156 12 15.2473 12H18.241ZM17.9625 29.4737V32.2105C17.9625 33.7544 16.8486 34.9473 15.2473 34.9473C13.6459 34.9473 12.532 33.7544 12.532 32.2105C12.532 30.6666 13.7156 29.4737 15.2473 29.4737H17.9625ZM33.2098 42.9473H25.4817C27.0134 41.8245 28.1274 40.421 28.8932 38.9473H33.0705C37.6656 38.9473 40.1024 35.7193 40.1024 32.2105C40.1024 28.7017 37.6656 25.4737 33.0705 25.4737H30.4945V21.4737H33.2098C39.4062 21.4737 44.2797 26.2456 44.2797 32.2105C44.2797 38.1754 39.4062 42.9473 33.2098 42.9473ZM30.216 34.9473C30.3553 34.1052 30.4945 33.1228 30.4945 32.2105V29.4737H33.2098C34.7415 29.4737 35.925 30.7368 35.925 32.2105C35.925 33.6842 34.7415 34.9473 33.2098 34.9473H30.216ZM30.4945 17.4737V14.7368C30.4945 13.193 31.6085 12 33.2098 12C34.8111 12 35.925 13.193 35.925 14.7368C35.925 16.2807 34.7415 17.4737 33.2098 17.4737H30.4945ZM42.5391 20.4912C41.4948 19.6491 40.172 18.9473 38.6403 18.4561C39.5454 17.4737 40.1024 16.0702 40.1024 14.4561C40.1024 10.4561 36.9694 7.99999 33.2794 7.99999C29.5894 7.99999 26.3172 10.5263 26.3172 14.7368V32.2105C26.3172 38.1754 21.374 42.9473 15.2473 42.9473C9.1205 42.9473 4.17733 38.3158 4.17733 32.2105C4.17733 30.0351 4.80393 28.1403 5.91788 26.4561C6.96222 27.2982 8.35466 28 9.81673 28.4912C8.91164 29.4737 8.35466 30.8772 8.35466 32.4912C8.35466 36.4912 11.4877 38.9473 15.1776 38.9473C18.8676 38.9473 22.1399 36.421 22.1399 32.2105V14.7368C22.1399 8.77192 27.083 4 33.2098 4C39.3365 4 44.2797 8.63157 44.2797 14.7368C44.2797 16.9123 43.6531 18.807 42.5391 20.4912Z"
      />
    </svg>
  ),
  arrowUp: (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="34" fill="none">
      <path
        fill="#fff"
        d="M16.414.586a2 2 0 0 0-2.828 0L.858 13.314a2 2 0 1 0 2.828 2.828L15 4.828l11.314 11.314a2 2 0 1 0 2.828-2.828L16.414.586ZM15 34h2V2h-4v32h2Z"
      />
    </svg>
  ),
  loopLogo: (
    <svg xmlns="http://www.w3.org/2000/svg" width="119" height="31" viewBox="0 0 119 31">
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize="14"
        fill="currentColor"
      >
        The Loop
      </text>
    </svg>
  ),
};

export default IconList;
